// Load the bundled jQuery, publish it globally and flush any ready-callbacks
// that legacy inline Blade scripts queued via the head stub before the ESM
// bundle had a chance to load.
var $ = require('jquery/dist/jquery.js');

window.$ = window.jQuery = $;

var queue = window.jQueryStubQueue || [];
queue.forEach(function (fn) {
    $(fn);
});
window.jQueryStubQueue = [];

module.exports = $;
